import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var Arrow = props => {
  var {
    Arrow: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'Arrow');
  return null;
};
Arrow.displayName = 'JVR.Arrow';